/**
 * Community Stats — count-up animation
 * - Triggers when in view (IntersectionObserver)
 * - Honors prefers-reduced-motion
 * - Per-block duration, delay, prefix/suffix, thousands separator
 */
(function () {
  'use strict';

  var prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function format(value, separator) {
    if (!separator) return String(value);
    return Number(value).toLocaleString('en-US');
  }

  function setText(el, value) {
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var separator = el.dataset.separator === 'true';
    el.textContent = prefix + format(value, separator) + suffix;
  }

  function animate(el) {
    var target = parseInt(el.dataset.count, 10) || 0;
    var duration = parseInt(el.dataset.duration, 10) || 1400;
    var delay = parseInt(el.dataset.delay, 10) || 0;
    var animate = el.dataset.animate === 'true';

    if (!animate || prefersReducedMotion || duration <= 0) {
      setText(el, target);
      return;
    }

    setTimeout(function () {
      var start = performance.now();
      function step(t) {
        var p = Math.min(1, (t - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        setText(el, Math.round(target * eased));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, delay);
  }

  function init() {
    var nodes = document.querySelectorAll('.community-stats__number[data-count]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(animate);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach(function (n) {
      io.observe(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section load
  if (typeof document !== 'undefined') {
    document.addEventListener('shopify:section:load', init);
  }
})();
